import { constants, IconStyleOverrides } from "@newsela/angelou";
import { CSSObject } from "@emotion/react";
import {
  partialCtaDefaultLinearGradientBackground,
  partialCtaHoverLinearGradientBackground,
} from "../AiComponents.style";

export const buttonCss: CSSObject = {
  ...partialCtaDefaultLinearGradientBackground,
  color: constants.colors.ui.white[700],
  ":hover:enabled": {
    ...partialCtaHoverLinearGradientBackground,
    cursor: "pointer",
  },
  ":focus:enabled": {
    ...partialCtaHoverLinearGradientBackground,
    cursor: "pointer",
  },
  ":active:enabled": {
    ...partialCtaHoverLinearGradientBackground,
  },
  ":disabled, :hover:disabled": {
    background: constants.colors.ui.neutral[100],
    color: constants.colors.ui.neutral[300],
    cursor: "not-allowed",
  },
};

export const removeIconCss: IconStyleOverrides<CSSObject> = {
  root: {
    display: "none",
  },
};
